import {algoliasearch} from "algoliasearch";
import {ID, KEY} from "../Constantes";

export const buscarPalabra = async ({palabra, coleccion}) => {


    const client = algoliasearch(ID, KEY);


    // Search for "query string" in the index "contacts"
    return client.search({
        requests: [{indexName: coleccion, query: palabra, hitsPerPage: 50}],
    }).then((res) => {

        if (res.results && res.results[0]) {

            let arr = res.results[0].hits.map((it) => {
                    delete it._highlightResult
                    return it
                }
            )


            return arr
        } else {
            return []
        }

    }).catch((r) => {
        return []
    })


}